import axios from 'axios';

export const http = axios.create({
    baseURL: 'https://apicd.editoradobrasil.com.br/api/', // Produção
    //baseURL: 'http://awscdapi.editoradobrasil.com.br/api/', // Homologação
    //baseURL: 'http://192.168.1.6:6158/api/',
    //baseURL: 'https://localhost:44396/api/',
    //baseURL: 'https://localhost:44386/api/', // LOCAL  
    headers: {
        'Content-Type': 'application/json',
    }
})

export const generateTokenAPI = axios.create({
    baseURL: 'https://api.editoradobrasil.com.br/AccessTokenGeneration-API/api/',
    //baseURL: 'http://192.168.11.30:8040/api/',

    headers: {
        'Content-Type': 'application/json',
    }
})  
